import { render, staticRenderFns } from "./AdminSteamBotProxy.vue?vue&type=template&id=67380acd&scoped=true&"
import script from "./AdminSteamBotProxy.vue?vue&type=script&lang=ts&"
export * from "./AdminSteamBotProxy.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSteamBotProxy.vue?vue&type=style&index=0&id=67380acd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67380acd",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QDialog,QCard,QCardSection,QSpace,QForm,QInput,QBtnToggle,QSelect,QToggle});qInstall(component, 'directives', {ClosePopup});
